import { Typography } from '@navi/web-ui/lib/primitives';
import React from 'react';
import cx from 'classnames';
import PerformanceMeter from '@cp/src/components/PerformanceMeter';
import { formatAmount } from '@cp/src/utils/commonUtils';
import Lottie from 'react-lottie';
import styles from './index.module.scss';
import useLottieAnimation from '@cp/src/hooks/useLottieAnimation';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

const CashCollectedProgressMeter = () => {
  const targetAchievedLottie = useLottieAnimation(
    () => import('@cp/src/assets/json/target-achieved-lottie.json'),
    'target-achieved-lottie'
  );
  const emiCollectedData = useSelector(
    (state: RootState) => state.telePerformanceDashboard.emiCollectedOverview
  );
  const { totalEmiAllocated, emiCollected, cycleEmiTarget } = emiCollectedData;

  const cycleEmiTargetForTooltip = cycleEmiTarget || totalEmiAllocated;

  const performanceForSvg = (emiCollected / totalEmiAllocated) * 100;
  const leftForTarget = cycleEmiTargetForTooltip - emiCollected;
  const moreThanTarget = emiCollected - cycleEmiTargetForTooltip;

  const performancePercentage = (emiCollected / cycleEmiTargetForTooltip) * 100;

  return (
    <div className={''}>
      <Typography variant="h6" color="var(--navi-color-gray-c2)">
        EMI Collected{' '}
      </Typography>
      <div className="flex items-center justify-center mt-6 px-8">
        <PerformanceMeter
          key="performance"
          startLimit={'₹0'}
          endLimit={formatAmount(totalEmiAllocated)}
          performance={performanceForSvg}
          showTooltip={true}
          tooltipContent={
            <div className="flex flex-col gap-1">
              <Typography variant="p4" color="var(--text-primary)">
                {`${performancePercentage.toFixed(0)}% Collected`}
              </Typography>

              <Typography variant="p4" color="var(--text-primary)">
                {performancePercentage < 100
                  ? `${formatAmount(leftForTarget)} Pending for goal`
                  : `${formatAmount(moreThanTarget)} more than goal`}
              </Typography>
            </div>
          }
          performancePercentage={performancePercentage}
          target={cycleEmiTargetForTooltip}
          showTarget={true}
          targetTooltipContent={
            <div className="flex flex-col justify-center items-center gap-1">
              <Typography variant="p4" color="var(--text-primary)">
                Goal
              </Typography>
              <Typography variant="p4" color="var(--text-primary)">
                {formatAmount(cycleEmiTargetForTooltip)}
              </Typography>
            </div>
          }
          width={240}
          height={240}
          bgColor={'var(--green-light-1)'}
          title={
            <>
              <Typography variant="h6" color="var(--grayscale-2)" className="font-medium">
                EMI Collected
              </Typography>
              <Typography
                variant="h1"
                color="var(--navi-color-blue-navigation)"
                className="font-semibold"
              >
                {formatAmount(emiCollected)}
              </Typography>
            </>
          }
          successAnimationLottie={
            targetAchievedLottie ? (
              <div className={styles.targetAchievedAnimation}>
                <Lottie
                  options={{
                    loop: false,
                    autoplay: true,
                    animationData: targetAchievedLottie,
                    rendererSettings: {
                      preserveAspectRatio: 'xMidYMid slice'
                    }
                  }}
                />
              </div>
            ) : null
          }
        />
      </div>
    </div>
  );
};

export default CashCollectedProgressMeter;
